import {
  cmToFeetAndInches,
  cmToMeters,
} from '@contracts/measurements/MeasurementUnits';
import type { TFunction } from 'i18next';

export {
  centimetersToInches,
  cmToFeetAndInches,
  cmToMeters,
  feetAndInchesToCm,
  feetAndInchesToInches,
  inchesToCentimeters,
  inchesToFeetAndInches,
  metersToCm,
} from '@contracts/measurements/MeasurementUnits';

export const toDisplayDimensionValue = ({
  value,
  showInMetric,
  t,
}: {
  value: number;
  showInMetric: boolean;
  t: TFunction;
}) => {
  if (showInMetric)
    return { value: cmToMeters(value), unit: t('units.meters') };
  return {
    value: cmToFeetAndInches(value),
    unit: t('units.feetAndInches'),
  };
};
